export default "__VITE_ASSET__DmAIkGlo__"